import type { ReactElement } from "react";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { CheckIcon } from "@heroicons/react/24/outline";

import classes from "./classes.module.scss";

export type IOption = {
	id: string;
	label: string | { text: string; subtext: string };
	notSelectable?: boolean;
};

function renderDropdownOptionLabel(
	label: string | { text: string; subtext: string },
	isActive: boolean,
): ReactElement {
	if (typeof label === "string") {
		return (
			<Typography
				typo={isActive ? ETypo.TEXT_MD_SEMIBOLD : ETypo.TEXT_MD_REGULAR}
				color={isActive ? ETypoColor.DROPDOWN_CONTRAST_ACTIVE : ETypoColor.DROPDOWN_CONTRAST_DEFAULT}>
				{label}
			</Typography>
		);
	}
	return (
		<div className={classes["content"]}>
			<Typography
				typo={ETypo.TEXT_MD_LIGHT}
				color={isActive ? ETypoColor.NAVIGATION_BUTTON_CONTRAST_ACTIVE : ETypoColor.NAVIGATION_BUTTON_CONTRAST_DEFAULT}>
				{label.text}
			</Typography>
			<Typography
				typo={ETypo.TEXT_MD_BOLD}
				color={isActive ? ETypoColor.NAVIGATION_BUTTON_CONTRAST_ACTIVE : ETypoColor.NAVIGATION_BUTTON_CONTRAST_DEFAULT}>
				{label.subtext}
			</Typography>
		</div>
	);
}

/** Contenu visuel d’une ligne de liste (le rôle `option` est posé sur le parent dans `DropdownMenu`). */
export function DropdownOptionLabelBlock(props: { option: IOption; isActive: boolean }): ReactElement {
	const { option, isActive } = props;
	return (
		<>
			{renderDropdownOptionLabel(option.label, isActive)}
			{isActive && <CheckIcon />}
		</>
	);
}

export { classes as dropdownOptionRowClasses };
